<template>
  <div class="comment-input-logo-container" @click="onClickComment">
    <div class="input-logo">
      <div class="input-box">我有话要说...</div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "CommentInputBox",
        methods: {
            onClickComment() {
                this.$emit('onClickComment')
            }
        }
    }
</script>

<style lang="scss" scoped>

.comment-input-logo-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;

  .input-logo {
    flex: 1 1 auto;
    height: 100%;
    padding: 10px 15px;

    .input-box {
      -webkit-border-radius: 25px;
      -moz-border-radius: 25px;
      border-radius: 25px;
      background: rgba(225, 226, 227, 0.55);
      color: rgba(135, 143, 145, 0.89);
      font-size: 12px;
      padding: 0 15px;
      line-height: 3;
    }
  }

  .icon-like {
    padding: 0 18px 0 5px;
    font-size: 14px;
  }
}
</style>